import { useState } from "react";

import { PrintReportTemplate } from "@/reports/PrintReportTemplate";
import { useCrosswordStore } from "@/store";

import { ConfirmModal } from "./ConfirmModal";

export function CheckButton() {
  const getSummaryReport = useCrosswordStore.use.getSummaryReport();
  const checkCrossword = useCrosswordStore.use.checkCrossword();
  const setGiraffeMood = useCrosswordStore.use.setGiraffeMood();
  const isChecked = useCrosswordStore.use.isChecked();
  const isCrosswordCompleted = useCrosswordStore.use.isCrosswordCompleted();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const finishActivity = () => {
    const report = getSummaryReport();
    const printData = PrintReportTemplate(report);
    window.approuter.finishActivityAndDone({ valid: true, printData });
  };

  const handleCheckAnswers = () => {
    setShowConfirmModal(false);
    setGiraffeMood("happy");
    checkCrossword();
  };

  const handleClick = () => {
    if (isChecked) {
      finishActivity();
    } else {
      setShowConfirmModal(true);
    }
  };

  const handleConfirm = () => {
    if (isChecked) {
      finishActivity();
    } else {
      handleCheckAnswers();
    }
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
  };

  const getButtonLabel = () => {
    if (isChecked) {
      return t("Done");
    }

    return t("Check Answers");
  };

  return (
    <>
      <button
        className="fixed right-4 bottom-4 flex h-10 cursor-pointer items-center gap-1 rounded-[20px] bg-[#59d797] px-4 text-white hover:bg-[#0eb168] disabled:cursor-default disabled:bg-[#42576ec4]"
        onClick={handleClick}
        aria-label={getButtonLabel()}
      >
        {getButtonLabel()}
      </button>

      <ConfirmModal
        open={showConfirmModal}
        onOpenChange={setShowConfirmModal}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        isForChecking={!isChecked}
        isCrosswordCompleted={isCrosswordCompleted()}
      />
    </>
  );
}
